<app-side-color-card color="primary-1">
  <div class="holder" content>
    <h3 class="title">Paletes mal alocados</h3>
    <div class="empty" *ngIf="!pallets?.length">Nenhum pallet mal alocado.</div>

    <div class="table" *ngIf="pallets?.length">
      <div class="header">
        <div class="col sku">Código do item</div>
        <div class="col">Qtd</div>
      </div>

      <ng-container *ngFor="let pallet of pallets">
        <div class="item" *ngFor="let product of pallet.skuGroups">
          <div class="col sku">{{ product.sku }}</div>
          <div class="col">{{ product.quantity * product.packSize }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</app-side-color-card>
